import { render } from "./Greetings.vue?vue&type=template&id=2c7ef002&scoped=true"
import script from "./Greetings.vue?vue&type=script&lang=js"
export * from "./Greetings.vue?vue&type=script&lang=js"

import "./Greetings.vue?vue&type=style&index=0&id=2c7ef002&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7ef002"]])

export default __exports__